export function phoneDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

export function formatPhone(value: string): string {
  const digits = phoneDigits(value);
  if (digits.length < 4) return digits ? `(${digits}` : '';
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function isValidPhone(value: string): boolean {
  return phoneDigits(value).length === 10;
}

export function isValidZip(value: string): boolean {
  return /^\d{5}$/.test(value.trim());
}

export function emailError(value: string, required = true): string {
  if (!value.trim()) return required ? 'Enter your email.' : '';
  if (!isValidEmail(value)) return 'Enter a valid email.';
  return '';
}

export function phoneError(value: string, required: boolean): string {
  if (!phoneDigits(value)) return required ? 'Enter a parent or guardian phone.' : '';
  if (!isValidPhone(value)) return 'Enter a 10-digit US phone number.';
  return '';
}

export function zipError(value: string): string {
  if (!/^\d{5}$/.test(value.trim())) return 'Enter a 5-digit zip code.';
  return '';
}
